import {createStore} from 'vuex'

export default createStore({
    state() {
        return {
            pageTitle: "Bibliothek",
            reevaluateLogin: 0,
            confirmationOverlay: {},
            breadCrumbs: [],
            user: null,
            toast: {},
            libraryRightClickOverlay: {},
            libraryRightClickOverlayActions: null,
            tenantConfig: null,
        }
    },
    getters: {},
    mutations: {
        setPageTitle(state, title) {
            state.pageTitle = title;
            const appName = state.tenantConfig?.name || 'Mediastelen';
            document.title = title + " | " + appName;
        },
        setTenantConfig(state, config) {
            state.tenantConfig = config;
            if(config?.logoUrl) {
                let link = document.querySelector("link[rel~='icon']");
                if(!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.head.appendChild(link);
                }
                link.href = config.logoUrl;
            }
        },
        setUser(state, user) {
            state.user = user;
        },
        setToast(state, status) {
            // visible:false bewusst durchlassen (zum Schliessen sticky-Toasts)
            if(status.visible !== false) {
                status.visible = true;
            }
            state.toast = status;
        },
        setRightClickActions(state, actions) {
            state.libraryRightClickOverlayActions = actions;
        }
    },
    actions: {},
    modules: {}
})
